import { useQuery } from '@tanstack/react-query';
import { workspaceService } from '../services/workspaceService';
import type { WorkspaceListItem } from '../services/workspaceService';

/**
 * Query key for workspace list.
 */
export const workspaceListQueryKey = ['workspaces', 'list'] as const;

/**
 * useWorkspaces
 *
 * Fetches the current user's workspaces with member and channel counts.
 * Uses React Query for caching, background refetching, and error handling.
 */
export function useWorkspaces() {
  return useQuery<WorkspaceListItem[], Error>({
    queryKey: workspaceListQueryKey,
    queryFn: () => workspaceService.list(),
    staleTime: 2 * 60 * 1000, // 2 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
}